<template lang="pug">
  div.site-header__search
    form(@submit.prevent="onSubmit" action="POST" autocomplete="off")
      .site-header__search-input
        .site-header__search-dropdown
          .site-header__search-dropdown-button(
              id="search-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            )
            span(v-if="!selected.category") All
            span(v-if="selected.category") {{ selected.category }}
            font-awesome-icon.dropdown-menu__toggle(:icon=['far', 'angle-down'])
          div.site-header__search-dropdown-menu.dropdown-menu(aria-labelledby="search-dropdown")
            span.site-header__search-dropdown-menu--title Filter by Category
            ul
              li.mobile-menu__list-item
                a.site-header__search-dropdown-item-link(
                  href="#" @click="selected.category = false"
                ) All
              li.mobile-menu__list-item(v-for="(item) in menu_items" :key="item.id")
                a.site-header__search-dropdown-item-link(
                  href="#" :title='item.name' @click="selected.category = item.slug"
                ) {{ item.name }}
        input.form-control(
          ref="searchInput"
          name="search"
          type="search",
          :placeholder='trans("labels.frontend.navigation.search_placeholder")'
          v-model="query"
          @focus="onFocus"
          @blur="onBlur"
        )
      .site-header__search-clear(@click="onClear" v-if="query")
        font-awesome-icon(:icon=['far', 'times'])
    transition(name="fade")
      div.site-header__search_results.text-center(v-if="status.isFetching")
        font-awesome-icon(:icon=['far', 'circle-notch'] spin)
    transition(name="fade")
      div.site-header__search_results(v-if="status.isActive && !status.isFetching && results && results.length > 0")
        vue-perfect-scrollbar.search-results
          .search-results__item.row.align-items-center(v-for="result in results" :key="result.id" @click="goToProduct(result)")
            .col-auto
              img.search-results__product-thumbnail(
                :src="'https://www.sparkinter.com/imageproduct/' + result.item_code + '.jpg'"
                v-if="result.item_code" alt='' width="60" height="auto"
              )
            .col
              h3.search-results__product-title {{ result.name }}
              .search-results-price(v-bind:class="{'search-results-price--discount': result.sale_price}" v-if="result.type === 'simple'")
                | ราคา
                span.search-results-price-value  {{ result.price | numeral }} ฿
                span.search-results-price-value.search-results-price-value--discount(v-if="result.sale_price") {{ result.sale_price | numeral }} ฿
              .search-results-price(v-if="result.type === 'variation'")
                | ราคา
                span.search-results-price-value  {{ result.min_price | numeral }} - {{ result.max_price | numeral }} ฿
    transition(name="fade")
      div.site-header__search_backdrop(v-if="status.isActive" @click.prevent="onBlur")
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar/index.vue'
import router from '../../routes';
import { RepositoryFactory } from '../../repositoryFactory';

const ProductRepository = RepositoryFactory.get('product');
const ProductCategoryRepository = RepositoryFactory.get('productCategory');

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      status: {
        isActive: false,
        isFetching: false,
      },
      query: '',
      results: [],
      menu_items: [],
      selected: {
        category: false,
      }
    };
  },
  watch: {
    $route(val, oldVal) {
      if (val.name === oldVal.name) return;
      if (val.name !== 'search.results') this.query = '';
    },
  },
  created() {
    this.getProductCategory();
  },
  mounted() {
    this.$watch('query', _.debounce((val, oldVal) => {
      if (val === oldVal) return;
      this.onFetch();
    }, 500));
  },
  methods: {
    async getProductCategory() {
      const { data } = await ProductCategoryRepository.get().then((resp) => resp.data);
      this.menu_items = data;
    },
    async onFetch() {
      if (this.query === '') return;
      this.status = { ...this.status, ...{ isFetching: true } };
      const { data } = await ProductRepository.search({ query: this.query, paginated: false, category: this.selected.category, per_page: 50 }).then((resp) => resp.data);
      this.results = data;
      this.status = { ...this.status, ...{ isFetching: false } };
    },
    onFocus() {
      console.log('on focus');
      this.status = { ...this.status, ...{ isActive: true } };
      this.onFetch();
    },
    onBlur() {
      console.log('onblur input');
      this.status = { ...this.status, ...{ isActive: false } };
      this.results = [];
    },
    onSubmit() {
      router.push({
        name: 'search.results',
        params: {
          query: this.query
        },
        query: this.selected.category ? {
          category: this.selected.category
        } : {}
      });
      this.status = { ...this.status, ...{ isActive: false } };
      this.$refs.searchInput.blur();
    },
    onClear() {
      this.query = '';
    },
    goToProduct(product) {
      this.query = '';
      router.push(product.permalink);
    },
  },
};
</script>
